import { getStorage } from 'firebase/storage';
import { getFirestore, serverTimestamp } from 'firebase/firestore';
import { initializeAppCheck, ReCaptchaV3Provider } from '@firebase/app-check';
import { initializeApp } from 'firebase/app';



const firebaseConfig = {
  apiKey: "AIzaSyDmUD72wMi650G5Mhfv1Nj--T5F0F8ua9I",
  authDomain: "freetime-s2-mytutorial.firebaseapp.com",
  projectId: "freetime-s2-mytutorial",
  storageBucket: "freetime-s2-mytutorial.appspot.com",
  messagingSenderId: "849579695133",
  appId: "1:849579695133:web:a0cb170b77c4e538d6faf4",
  measurementId: "G-S2G5Y9X9QN"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Pass your reCAPTCHA v3 site key (public key) to activate().
initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider('6Le8ahUpAAAAANUX7UcAcTVTs-Onyg5rf_ofSVFQ'),
  isTokenAutoRefreshEnabled: true // Optional argument
});



const projectStorage = getStorage(app);
const projectFirestore = getFirestore(app);
const timestamp = serverTimestamp;

export { projectStorage, projectFirestore, timestamp};